import { Link } from "react-router-dom"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/users/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "@/pages/users/Model"
import { useState } from "react"
import { CrudProvider } from "@/context/crudContext"

export default function UserList() {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Users</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="//">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Users</li>
        </ul>
      </div>

      <CrudProvider>
        <UserTable />
      </CrudProvider>
    </>
  )
}

function UserTable() {
  return (
    <>
      <CustomTable label="Users" columns={columns} apiPath="user" />

      <Modal />
    </>
  )
}
